import { useFiatBalance } from 'hooks/wallets/useFiatBalance';
import { faFiatCurrencySymbols } from 'lib/fiat';

import { PaymentMethodIcon, Props as PaymentMethodIconProps } from '..';

type Props = Pick<PaymentMethodIconProps, 'size'>;

export const FiatWalletIcon = ({ size }: Props) => {
  const { fiatCurrency } = useFiatBalance();
  return (
    <PaymentMethodIcon
      size={size}
      backgroundColor="var(--c-onBase-success)"
      color="var(--c-white)"
      icon={faFiatCurrencySymbols[fiatCurrency]}
    />
  );
};
